module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/superlogin-client/~/axios/index.js
// module id = 794
// module chunks = 7